import React, { useEffect, useState } from "react";
import "../Css/SuccessPage.css";
import BrandLoader from '../Component/Loading/BrandLoader';

import { PiSealCheckFill } from "react-icons/pi";

import {
    FiMapPin,
    FiPackage,
    FiCreditCard,
    FiArrowRight,
    FiShoppingBag,
    FiDownload,
    FiFileText
} from "react-icons/fi";

import { API_BASE_URL } from "../services/apiConfig";

import { Link, useParams } from "react-router-dom";

import deliverymanriding from "../Images/delivery-man-riding.png";

import { get } from "../services/ApiRouting";

import moment from "moment";
import { useCurrency } from "../services/locationService";


const SuccessPage = () => {

    const { order_id } = useParams();

    const [order, setOrder] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const [invoiceLoading, setInvoiceLoading] =
        useState(false);
    const { format: formatCurrency } = useCurrency();


    // =====================================================
    // FETCH ORDER
    // =====================================================

    useEffect(() => {

        const fetchOrder = async () => {

            if (!order_id) {
                setError("Order ID is missing.");
                setLoading(false);
                return;
            }

            try {

                setLoading(true);
                setError("");

                const response = await get(
                    `payments/orders?order_id=${order_id}`
                );

                console.log(
                    "Order Response:",
                    response
                );

                if (
                    response?.success &&
                    response?.orders?.length
                ) {

                    setOrder(
                        response.orders[0]
                    );

                } else {

                    setError(
                        "Order details not found."
                    );
                }

            } catch (err) {

                console.error(
                    "Order Fetch Error:",
                    err
                );

                setError(
                    "Unable to load your order details."
                );

            } finally {

                setLoading(false);

            }

        };


        fetchOrder();

    }, [order_id]);


    // =====================================================
    // DOWNLOAD / GENERATE INVOICE
    // =====================================================

    const handleInvoiceDownload = async () => {

        if (!currentOrderId) {
            return;
        }

        try {

            setInvoiceLoading(true);

            const backendOrigin = API_BASE_URL.replace(/\/api\/?$/, "");
            const invoiceUrl = invoice_pdf?.startsWith("http")
                ? invoice_pdf
                : `${backendOrigin}/${invoice_pdf?.replace(/^\//, "")}`;

            const response = await fetch(invoiceUrl);
            if (!response.ok) {
                throw new Error("Unable to download invoice.");
            }

            const blobUrl = window.URL.createObjectURL(await response.blob());

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = invoice_number
                ? `${invoice_number}.pdf`
                : `${order_number || currentOrderId}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);


        } catch (err) {

            console.error(
                "Invoice Download Error:",
                err
            );

            alert(
                err?.message ||
                "Unable to download invoice."
            );

        } finally {

            setInvoiceLoading(false);

        }

    };


    // =====================================================
    // LOADING
    // =====================================================

    if (loading) {
        return <BrandLoader message="Loading your order..." />;

    }


    // =====================================================
    // ERROR
    // =====================================================

    if (error || !order) {

        return (

            <section className="success-page">

                <div className="success-error">

                    <FiPackage />

                    <h2>
                        Order Not Found
                    </h2>

                    <p>
                        {error ||
                            "We couldn't find this order."}
                    </p>

                    <Link to="/">
                        Back to Home
                    </Link>

                </div>

            </section>

        );

    }


    // =====================================================
    // ORDER DATA
    // =====================================================

    const {
        order_id: currentOrderId,

        order_number,

        subtotal,

        shipping_amount,

        discount_amount,

        total_amount,

        currency,

        payment_method,

        payment_status,

        order_status,

        order_created_at,

        user_name,

        user_phone,

        delivery_phone,

        address_line1,

        city,

        state,

        postal_code,

        country_name,

        invoice_number,

        invoice_pdf,

        invoice_generated_at,

        items = []

    } = order;


    // =====================================================
    // AMOUNTS
    // =====================================================

    const subtotalValue =
        Number(subtotal || 0);


    const shippingValue =
        Number(shipping_amount || 0);


    const discountValue =
        Number(discount_amount || 0);


    const totalValue =
        Number(total_amount || 0);


    /*
     * If subtotal contains 18% GST
     */

    const basePrice =
        Math.round(
            subtotalValue / 1.18
        );


    const tax =
        Math.round(
            subtotalValue - basePrice
        );


    // =====================================================
    // STATUS
    // =====================================================

    const normalizedStatus =
        String(order_status || "")
            .toLowerCase();


    const normalizedPaymentStatus =
        String(payment_status || "")
            .toLowerCase();


    const isPaid =
        normalizedPaymentStatus === "paid";


    const isProcessing =
        normalizedStatus === "processing" ||
        normalizedStatus === "shipped" ||
        normalizedStatus === "delivered";


    const isShipped =
        normalizedStatus === "shipped" ||
        normalizedStatus === "delivered";


    const isDelivered =
        normalizedStatus === "delivered";


    // =====================================================
    // FORMAT CURRENCY
    // =====================================================

    const formatPrice = formatCurrency;


    // =====================================================
    // IMAGE URL HELPER
    // =====================================================

    const getImageUrl = (image) => {

        if (!image) {
            return null;
        }

        /*
         * If backend already returns complete URL
         */

        if (
            image.startsWith("http://") ||
            image.startsWith("https://")
        ) {
            return image;
        }


        /*
         * VITE API URL
         */




        return `https://1fiveglobal.in/${image.replace(/^\//, "")}`;

    };


    // =====================================================
    // RENDER
    // =====================================================

    return (

        <section className="success-page">

            <div className="success-container">


                {/* =================================================
                    HERO
                ================================================= */}

                <div className="success-hero">

                    <div className="success-icon">

                        <PiSealCheckFill />

                    </div>


                    <div className="success-hero-content">

                        <span className="success-eyebrow">

                            PAYMENT SUCCESSFUL

                        </span>


                        <h1>

                            Your order is confirmed.

                        </h1>


                        <p>

                            Thank you for shopping with
                            1Five. We've received your
                            order and our team is preparing
                            it with care.

                        </p>

                    </div>


                    <div className="order-reference">

                        <span>
                            ORDER NUMBER
                        </span>

                        <strong>
                            {order_number}
                        </strong>

                    </div>

                </div>



                {/* =================================================
                    INVOICE CARD
                ================================================= */}

                {isPaid && (

                    <div className="invoice-card">

                        <div className="invoice-card-left">

                            <div className="invoice-icon">

                                <FiFileText />

                            </div>


                            <div>

                                <span className="invoice-label">

                                    PAYMENT RECEIPT

                                </span>


                                <h3>

                                    Your invoice is ready

                                </h3>


                                <p>

                                    {invoice_number
                                        ? `Invoice ${invoice_number}`
                                        : "Your paid order invoice is available."
                                    }

                                </p>

                            </div>

                        </div>


                        <div className="invoice-card-right">

                            <button
                                type="button"
                                className="invoice-action"
                                onClick={
                                    handleInvoiceDownload
                                }
                                disabled={
                                    invoiceLoading
                                }
                            >

                                {invoiceLoading ? (

                                    <>
                                        <span className="invoice-spinner"></span>

                                        <span>
                                            Preparing invoice...
                                        </span>
                                    </>

                                ) : (

                                    <>

                                        <FiDownload />

                                        <span>

                                            {invoice_number
                                                ? `Download ${invoice_number}`
                                                : "Download Invoice"
                                            }

                                        </span>

                                    </>

                                )}

                            </button>

                        </div>

                    </div>

                )}



                {/* =================================================
                    ORDER META
                ================================================= */}

                <div className="order-meta">


                    <div className="meta-item">

                        <FiPackage />

                        <div>

                            <span>
                                Order ID
                            </span>

                            <strong>
                                #{currentOrderId}
                            </strong>

                        </div>

                    </div>



                    <div className="meta-item">

                        <FiCreditCard />

                        <div>

                            <span>
                                Payment
                            </span>

                            <strong
                                className={
                                    isPaid
                                        ? "payment-paid"
                                        : ""
                                }
                            >
                                {payment_status}
                            </strong>

                        </div>

                    </div>



                    <div className="meta-item">

                        <FiShoppingBag />

                        <div>

                            <span>
                                Ordered on
                            </span>

                            <strong>

                                {moment(
                                    order_created_at
                                ).format(
                                    "DD MMM YYYY"
                                )}

                            </strong>

                        </div>

                    </div>


                </div>



                {/* =================================================
                    ORDER TRACKING
                ================================================= */}

                <div className="tracking-card">


                    <div className="section-heading">

                        <div>

                            <span>
                                YOUR ORDER
                            </span>

                            <h2>
                                Order progress
                            </h2>

                        </div>


                        <div className="status-badge">

                            {order_status}

                        </div>

                    </div>



                    <div className="tracking-line">


                        {/* STEP 1 */}

                        <div className="tracking-step active">

                            <div className="step-circle">

                                <PiSealCheckFill />

                            </div>


                            <div className="step-content">

                                <strong>
                                    Confirmed
                                </strong>

                                <span>
                                    Payment received
                                </span>

                            </div>

                        </div>



                        {/* LINE */}

                        <div
                            className={`tracking-progress ${
                                isProcessing
                                    ? "filled"
                                    : ""
                            }`}
                        ></div>



                        {/* STEP 2 */}

                        <div
                            className={`tracking-step ${
                                isProcessing
                                    ? "active"
                                    : ""
                            }`}
                        >

                            <div className="step-circle">

                                <FiPackage />

                            </div>


                            <div className="step-content">

                                <strong>
                                    Processing
                                </strong>

                                <span>
                                    Preparing your order
                                </span>

                            </div>

                        </div>



                        {/* LINE */}

                        <div
                            className={`tracking-progress ${
                                isShipped
                                    ? "filled"
                                    : ""
                            }`}
                        ></div>



                        {/* STEP 3 */}

                        <div
                            className={`tracking-step ${
                                isShipped
                                    ? "active"
                                    : ""
                            }`}
                        >

                            <div className="step-circle">

                                <FiShoppingBag />

                            </div>


                            <div className="step-content">

                                <strong>
                                    Shipped
                                </strong>

                                <span>
                                    On the way
                                </span>

                            </div>

                        </div>



                        {/* LINE */}

                        <div
                            className={`tracking-progress ${
                                isDelivered
                                    ? "filled"
                                    : ""
                            }`}
                        ></div>



                        {/* STEP 4 */}

                        <div
                            className={`tracking-step ${
                                isDelivered
                                    ? "active"
                                    : ""
                            }`}
                        >

                            <div className="step-circle">

                                <PiSealCheckFill />

                            </div>


                            <div className="step-content">

                                <strong>
                                    Delivered
                                </strong>

                                <span>
                                    Enjoy your purchase
                                </span>

                            </div>

                        </div>


                    </div>

                </div>



                {/* =================================================
                    MAIN GRID
                ================================================= */}

                <div className="success-grid">


                    {/* =================================================
                        LEFT
                    ================================================= */}

                    <div className="success-left">


                        {/* =================================================
                            PRODUCTS
                        ================================================= */}

                        <div className="products-card">


                            <div className="section-heading">

                                <div>

                                    <span>
                                        ORDER ITEMS
                                    </span>

                                    <h2>
                                        Your purchase
                                    </h2>

                                </div>


                                <span className="item-count">

                                    {items.length}{" "}

                                    {items.length === 1
                                        ? "item"
                                        : "items"}

                                </span>

                            </div>



                            <div className="products-list">


                                {items.length > 0 ? (

                                    items.map(
                                        (item, index) => {

                                            const imageUrl =
                                                getImageUrl(
                                                    item.order_item_image_url ||
                                                    item.order_item_image
                                                );


                                            return (

                                                <div
                                                    className="product-item"
                                                    key={
                                                        item.order_item_id ||
                                                        index
                                                    }
                                                >


                                                    {/* IMAGE */}

                                                    <div className="product-image">

                                                        {imageUrl ? (

                                                            <img
                                                                src={
                                                                    imageUrl
                                                                }
                                                                alt={
                                                                    item.product_name
                                                                }
                                                                onError={(
                                                                    e
                                                                ) => {

                                                                    e.currentTarget.style.display =
                                                                        "none";

                                                                    const fallback =
                                                                        e.currentTarget.parentElement.querySelector(
                                                                            ".no-image"
                                                                        );

                                                                    if (
                                                                        fallback
                                                                    ) {
                                                                        fallback.style.display =
                                                                            "flex";
                                                                    }

                                                                }}
                                                            />

                                                        ) : null}


                                                        <div
                                                            className="no-image"
                                                            style={{
                                                                display:
                                                                    imageUrl
                                                                        ? "none"
                                                                        : "flex"
                                                            }}
                                                        >

                                                            <FiShoppingBag />

                                                        </div>

                                                    </div>



                                                    {/* DETAILS */}

                                                    <div className="product-info">


                                                        <span className="product-code">

                                                            {item.product_code ||
                                                                "PRODUCT"}

                                                        </span>


                                                        <h3>

                                                            {
                                                                item.product_name
                                                            }

                                                        </h3>



                                                        <div className="product-options">


                                                            <span>

                                                                Color

                                                                <strong>

                                                                    {
                                                                        item.color_name ||
                                                                        "N/A"
                                                                    }

                                                                </strong>

                                                            </span>



                                                            <span>

                                                                Size

                                                                <strong>

                                                                    {
                                                                        item.size_name ||
                                                                        "N/A"
                                                                    }

                                                                </strong>

                                                            </span>



                                                            <span>

                                                                Qty

                                                                <strong>

                                                                    {
                                                                        item.quantity
                                                                    }

                                                                </strong>

                                                            </span>


                                                        </div>


                                                    </div>



                                                    {/* PRICE */}

                                                    <div className="product-price">

                                                        <span>

                                                            {currency}

                                                        </span>


                                                        <strong>

                                                            {formatPrice(
                                                                item.subtotal
                                                            )}

                                                        </strong>

                                                    </div>


                                                </div>

                                            );

                                        }
                                    )

                                ) : (

                                    <div className="empty-products">

                                        <FiShoppingBag />

                                        <p>
                                            No items found in this order.
                                        </p>

                                    </div>

                                )}

                            </div>

                        </div>



                        {/* =================================================
                            DELIVERY
                        ================================================= */}

                        <div className="delivery-card">


                            <div className="delivery-info">


                                <div className="section-heading">

                                    <div>

                                        <span>
                                            DELIVERY
                                        </span>

                                        <h2>
                                            Shipping address
                                        </h2>

                                    </div>


                                    <FiMapPin />

                                </div>



                                <div className="address-content">


                                    <h3>
                                        {user_name}
                                    </h3>


                                    <p>

                                        {address_line1}

                                        <br />

                                        {city},{" "}
                                        {state} -{" "}
                                        {postal_code}

                                        <br />

                                        {country_name}

                                    </p>



                                    <div className="phone">

                                        <span>
                                            Phone
                                        </span>

                                        <strong>

                                            {
                                                delivery_phone ||
                                                user_phone
                                            }

                                        </strong>

                                    </div>

                                </div>

                            </div>



                            <div className="delivery-visual">

                                <img
                                    src={
                                        deliverymanriding
                                    }
                                    alt="Delivery"
                                />

                                <span>

                                    We're getting
                                    your order ready

                                </span>

                            </div>


                        </div>


                    </div>



                    {/* =================================================
                        RIGHT SUMMARY
                    ================================================= */}

                    <aside className="summary-card">


                        <div className="summary-top">

                            <span>
                                PAYMENT SUMMARY
                            </span>

                            <h2>
                                Order total
                            </h2>

                        </div>



                        <div className="summary-lines">


                            <div>

                                <span>
                                    Subtotal
                                </span>

                                <strong>

                                    {currency}{" "}

                                    {formatPrice(
                                        subtotalValue
                                    )}

                                </strong>

                            </div>



                            <div>

                                <span>
                                    Shipping
                                </span>

                                <strong>

                                    {shippingValue === 0
                                        ? "FREE"
                                        : formatPrice(shippingValue)}

                                </strong>

                            </div>



                            <div>

                                <span>
                                    Discount
                                </span>

                                <strong>

                                    {discountValue > 0
                                        ? `- ${formatPrice(discountValue)}`
                                        : "—"}

                                </strong>

                            </div>



                            <div>

                                <span>
                                    Tax (18%)
                                </span>

                                <strong>

                                    {currency}{" "}

                                    {formatPrice(
                                        tax
                                    )}

                                </strong>

                            </div>


                        </div>



                        <div className="summary-total">

                            <span>
                                Total paid
                            </span>

                            <strong>

                                {currency}{" "}

                                {formatPrice(
                                    totalValue
                                )}

                            </strong>

                        </div>



                        <div className="payment-method">

                            <FiCreditCard />

                            <div>

                                <span>
                                    Paid via
                                </span>

                                <strong>
                                    {payment_method}
                                </strong>

                            </div>


                            <PiSealCheckFill />

                        </div>



                        <div className="summary-note">

                            <PiSealCheckFill />

                            <p>

                                Your payment has been
                                successfully verified.

                            </p>

                        </div>


                    </aside>


                </div>



                {/* =================================================
                    FOOTER ACTIONS
                ================================================= */}

                <div className="success-actions">


                    <Link
                        to="/"
                        className="secondary-action"
                    >

                        <span>
                            Back to home
                        </span>

                    </Link>



                    {/* INVOICE */}

                    {isPaid && (

                        <button
                            type="button"
                            className="invoice-action footer-invoice-action"
                            onClick={
                                handleInvoiceDownload
                            }
                            disabled={
                                invoiceLoading
                            }
                        >

                            {invoiceLoading ? (

                                <>
                                    <span className="invoice-spinner"></span>

                                    <span>
                                        Preparing invoice...
                                    </span>
                                </>

                            ) : (

                                <>
                                    <FiFileText />

                                    <span>

                                        {invoice_number
                                            ? `Invoice ${invoice_number}`
                                            : "Download Invoice"
                                        }

                                    </span>

                                    <FiDownload />

                                </>

                            )}

                        </button>

                    )}



                    <Link
                        to="/"
                        className="primary-action"
                    >

                        <span>
                            Continue shopping
                        </span>

                        <FiArrowRight />

                    </Link>


                </div>



                {/* =================================================
                    INVOICE INFORMATION
                ================================================= */}

                {isPaid && invoice_number && (

                    <div className="invoice-footer-info">

                        <FiFileText />

                        <span>

                            Invoice:
                            <strong>
                                {invoice_number}
                            </strong>

                        </span>


                        {invoice_generated_at && (

                            <span>

                                Generated on{" "}

                                <strong>

                                    {moment(
                                        invoice_generated_at
                                    ).format(
                                        "DD MMM YYYY, hh:mm A"
                                    )}

                                </strong>

                            </span>

                        )}

                    </div>

                )}


            </div>

        </section>

    );

};


export default SuccessPage;
